import { datadogRum } from '@datadog/browser-rum'
import { getUrl as getPartnerBenefitGraphUrl } from 'enrollment-platform/api/partner-benefit-graph/client'
import { getApiUrl } from 'modules/enrollment-platform-api'

import { isTrackingDisabledOnCurrentPath } from './trackingDisabledPaths'

let datadogRumInitialized = false

export function isDatadogRumInitialized(): boolean {
  return datadogRumInitialized
}

function disableDatadogRumTracking(): void {
  if (!datadogRumInitialized) {
    return
  }

  try {
    datadogRum.setTrackingConsent('not-granted')
    datadogRum.stopSessionReplayRecording()
    datadogRum.stopSession()
    datadogRum.clearUser()
  } catch (error) {
    console.error(error)
  }
}

function enableDatadogRumTracking(): void {
  if (!datadogRumInitialized) {
    return
  }

  try {
    datadogRum.setTrackingConsent('granted')
  } catch (error) {
    console.error(error)
  }
}

export function initDatadogRumIfAllowed(): void {
  if (isTrackingDisabledOnCurrentPath()) {
    disableDatadogRumTracking()
    return
  }

  if (datadogRumInitialized) {
    enableDatadogRumTracking()
    return
  }

  const applicationId = process.env.DATADOG_APP_ID
  const clientToken = process.env.DATADOG_CLIENT_TOKEN
  if (!applicationId || !clientToken) {
    return
  }

  datadogRum.init({
    applicationId,
    clientToken,
    site: 'datadoghq.com',
    service: 'admin-enrollment-platform',
    env: process.env.ENV,
    version: process.env.COMMIT_SHA,
    sessionSampleRate: 100,
    sessionReplaySampleRate: 20,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: 'mask-user-input',
    allowedTracingUrls: [getApiUrl(), getPartnerBenefitGraphUrl()].map(
      (origin) => ({
        match: (url: string) => url.startsWith(origin),
        propagatorTypes: ['tracecontext'],
      })
    ),
  })

  datadogRumInitialized = true
}
